export const BANK_NAMES = [
  "토스뱅크",
  "카카오뱅크",
  "케이뱅크",
  "국민은행",
  "신한은행",
  "우리은행",
  "기업은행",
  "농협은행",
  "하나은행",
  "SC제일은행",
  "우체국은행",
  "씨티은행",
  "산업은행",
  "부산은행",
  "경남은행",
  "대구은행",
  "광주은행",
  "전북은행",
  "제주은행",
  "새마을금고",
  "신협",
  "수협",
];

export const VEHICLE_TYPE_LABELS = {
  compactSedan: '일반승용차(소형, 준중형)',
  midsizeSuv: '일반승용차(중형, SUV)',
  oneTonTruck: '1톤 트럭',
  van: '승합차(스타리아/스타렉스)',
  motorcycle: '오토바이/이륜차',
};